"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TangleRequestType = void 0;
var TangleRequestType;
(function (TangleRequestType) {
    TangleRequestType["ADDRESS_VALIDATION"] = "ADDRESS_VALIDATION";
    TangleRequestType["SELL_TOKEN"] = "SELL_TOKEN";
    TangleRequestType["BUY_TOKEN"] = "BUY_TOKEN";
    TangleRequestType["STAKE"] = "STAKE";
    TangleRequestType["NFT_PURCHASE"] = "NFT_PURCHASE";
    TangleRequestType["NFT_PURCHASE_BULK"] = "NFT_PURCHASE_BULK";
    TangleRequestType["NFT_BID"] = "NFT_BID";
    TangleRequestType["NFT_SET_FOR_SALE"] = "NFT_SET_FOR_SALE";
    TangleRequestType["NFT_TRANSFER"] = "NFT_TRANSFER";
    TangleRequestType["CLAIM_MINTED_AIRDROPS"] = "CLAIM_MINTED_AIRDROPS";
    TangleRequestType["AWARD_CREATE"] = "AWARD_CREATE";
    TangleRequestType["AWARD_FUND"] = "AWARD_FUND";
    TangleRequestType["AWARD_APPROVE_PARTICIPANT"] = "AWARD_APPROVE_PARTICIPANT";
    TangleRequestType["PROPOSAL_CREATE"] = "PROPOSAL_CREATE";
    TangleRequestType["PROPOSAL_APPROVE"] = "PROPOSAL_APPROVE";
    TangleRequestType["PROPOSAL_REJECT"] = "PROPOSAL_REJECT";
    TangleRequestType["PROPOSAL_VOTE"] = "PROPOSAL_VOTE";
    TangleRequestType["SPACE_CREATE"] = "SPACE_CREATE";
    TangleRequestType["SPACE_JOIN"] = "SPACE_JOIN";
    TangleRequestType["SPACE_ADD_GUARDIAN"] = "SPACE_ADD_GUARDIAN";
    TangleRequestType["SPACE_REMOVE_GUARDIAN"] = "SPACE_REMOVE_GUARDIAN";
    TangleRequestType["SPACE_ACCEPT_MEMBER"] = "SPACE_ACCEPT_MEMBER";
    TangleRequestType["SPACE_BLOCK_MEMBER"] = "SPACE_BLOCK_MEMBER";
    TangleRequestType["SPACE_DECLINE_MEMBER"] = "SPACE_DECLINE_MEMBER";
    TangleRequestType["SPACE_LEAVE"] = "SPACE_LEAVE";
    TangleRequestType["MINT_METADATA_NFT"] = "MINT_METADATA_NFT";
    TangleRequestType["STAMP"] = "STAMP";
    TangleRequestType["CREATE_AUCTION"] = "CREATE_AUCTION";
    TangleRequestType["BID_AUCTION"] = "BID_AUCTION";
    TangleRequestType["CREATE_SWAP"] = "CREATE_SWAP";
    TangleRequestType["SET_SWAP_FUNDED"] = "SET_SWAP_FUNDED";
    TangleRequestType["REJECT_SWAP"] = "REJECT_SWAP";
    TangleRequestType["VERIFY_ETH_ADDRESS"] = "VERIFY_ETH_ADDRESS";
})(TangleRequestType || (exports.TangleRequestType = TangleRequestType = {}));
